export default __webpack_public_path__ + "static/media/pokeball_icon.08ea1ead.svg";